import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, FieldArray, reduxForm } from 'redux-form';
import { getTargetDetails, saveTarget } from './actions/targetActions';
import { renderCheckBox, renderTextField, renderAutoCompleteSingleSelect, renderTextArea, isInteger } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import SmallLoader from '../../../../../img/small-loader.gif';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../../actions/utilAction';
import { getMasterData } from './../domain/actions/domainActions';

class TargetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      targetId: props.targetId,
      targetName:"",
      //masterPrograms: this.props.masterPrograms,
      showTaskAnalysisStep: false,
      masterDomains: [],
      masterPrograms: [],
      filteredPrograms:[],
      programId:0
    };
  }

  componentWillMount() {
    if (this.state.targetId) {
      this.props.getTargetDetails(this.state.targetId);
    }
    let masterData = { 'masterdata': 'MASTERDOMAINS,MASTERPROGRAMS,MASTERDESIREDDAILYTRIALS,MASTERAUTOOPENORDER,MASTERTARGETTYPE,MASTERRESPONSEPERCENTAGE,MASTERCONSECUTIVEDAYS,MASTERFIRSTTRIALMUSTBEINDEPENDENT' };
    this.props.getMasterData(masterData);


    let filteredProgram = null;

    let msterProg = null;
    msterProg = this.props.masterPrograms

    console.log(msterProg);
    
    if(this.props.programId){
      filteredProgram = msterProg.filter((obj)=>{return obj.id===this.props.programId})

      this.setState({filteredPrograms:filteredProgram})
    }

    console.log(filteredProgram);
    
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };


  middleWare = (input,selectedRecord)=>{
     input.onChange(selectedRecord.value);  
    if(input.name === 'targetTypeId')
      {
        if(selectedRecord.label === 'Task Analysis')
        { 
          this.setState({showTaskAnalysisStep: true});        
        }
        else
        {
          this.setState({showTaskAnalysisStep: false});
        }      
    }
      let pgId = 0;
      if(this.props.programId){
        pgId = this.props.programId
      }
      let addcolString = `${selectedRecord.value},${pgId>0?pgId:this.state.programId}` 
        let postData = {
        'AdditionalColmnId':addcolString, 
        'labelName': "Target Name",
        'tableName':"DCMASTER_TARGETS_TARGETNAME",
        'value': this.state.targetName,
        'colmnName':"TARGETNAME",
        'id': this.state.targetId || 0, 
      };
      
      this.props.checkFieldExistence(postData);
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.domainIdForTarget && this.props.programId) {      
    //   this.props.dispatch(change('TargetModalForm', 'domainId', this.props.domainIdForTarget));
    //   this.props.dispatch(change('TargetModalForm', 'programId', this.props.programId));
    // }
    let masterDomains = [];
    let masterPrograms =[];
    if(nextProps.masterDomains !== null && nextProps.masterDomains.length !== 0) {
        masterDomains = nextProps.masterDomains.filter(obj => {
            return obj.libraryId === this.props.curriculumLibraryId
        })
    }
    if(nextProps.masterPrograms !== null && nextProps.masterPrograms.length !== 0) {
        masterPrograms = nextProps.masterPrograms
    }

    
    this.setState({
      masterDomains: masterDomains,
      masterPrograms: masterPrograms,
    }, ()=>{
      console.log('this.props.programId...............',this.props.programId)
      this.props.dispatch(change('TargetModalForm', 'domainId', this.props.domainIdForTarget));
      this.props.dispatch(change('TargetModalForm', 'programId', this.props.programId));
    });

    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

    if (nextProps.targetTypeName && nextProps.targetTypeName !== this.props.targetTypeName && nextProps.targetTypeName === 'Task Analysis'){  
      this.setState({showTaskAnalysisStep: true});      
    }

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let postData = {
      "id": this.props.targetId || 0,
      "domainId": this.props.domainIdForTarget || formProps.domainId,
      "domainName": '',
      "programId": this.props.programId || formProps.programId,
      "programName": " ",
      "targetName": formProps.targetName,
      "goalName": formProps.goalName,
      "generalizatonPlan": formProps.generalizatonPlan,      
      "sd": formProps.sd,
      "targetInstructions": formProps.targetInstructions,
      "desiredDailyTrialsId": formProps.desiredDailyTrialsId || null,
      "autoOpenOrderId": null,
      "autoOpen": "",
      "targetTypeId": formProps.targetTypeId || 0,
      "targetType": " ",
      "responsePercentageId": formProps.responsePercentageId || null,
      "consecutiveDaysId": formProps.consecutiveDaysId || null,
      "firstTrialMustBeIndependentId": formProps.firstTrialMustBeIndependentId || null,
      "isActive": formProps.isActive || 0
    }

    // ---------------Start Save to taskAnalysisModel in master target------------    
    let listTaskAnalysis = [];
    if (formProps.taskAnalysisModel && formProps.taskAnalysisModel.length) { 
      formProps.taskAnalysisModel.filter((data, i) => {
        if (data.taskName && data.displayOrder) {
          let taskAnalysis = {           
            'taskAnalysisId': data.taskAnalysisId || 0,            
            'targetId': data.targetId ? data.targetId : this.props.targetId ? this.props.targetId : 0,
            'taskName': data.taskName,          
            'displayOrder': parseInt(data.displayOrder),
          };
          listTaskAnalysis.push(taskAnalysis);
        }
        return listTaskAnalysis;
      });
    }
    postData.dcMasterTargetTaskAnalysisModel = listTaskAnalysis;
    // ---------------End Save to taskAnalysisModel in master target------------

    this.props.clearFieldErrorArray();
    this.props.saveTarget(postData, 0, 0);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    this.setState({targetName:value})

    // if (value.length > 0) {
    //   let postData = {
    //     'labelName': labelName,
    //     'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
    //     'value': value,
    //     'colmnName': input.target.name.toUpperCase(),
    //     'id': this.state.targetId || 0,
    //   };
    //   this.props.checkFieldExistence(postData);
    // }
  };

  handleNewRequest = (input, selectedRecord) => {
    if(input.name==="programId") {
      this.setState({programId:selectedRecord.value})
    }
    input.onChange(selectedRecord.value);
    if(input.name === "domainId") {
        if(!selectedRecord.value){
           this.props.dispatch(change("TargetModalForm","programId",null))
        }
        let filteredPrograms = this.state.masterPrograms.filter(obj => {
        return obj.domainId === selectedRecord.value
      })
      this.setState({
        filteredPrograms : filteredPrograms
      })  
    } else if(input.name === 'targetTypeId')
      {
        if(selectedRecord.label === 'Task Analysis')
        { 
          this.setState({showTaskAnalysisStep: true});        
        }
        else
        {
          this.setState({showTaskAnalysisStep: false});
        }      
      }
  };

  addTaskRow = () => { };
  removeTaskRow = (i) => { };

  renderTaskAnalysisTemplate = ({ fields }) => {
    this.addTaskRow = (e) => {
      fields.push({});
    };

    this.removeTaskRow = (i, e) => {
      fields.remove(i);
    };

    return (
      <div>
        {fields.map((taskAnalysisModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-7 require">
              <Field
                name={`taskAnalysisModel[${i}].taskName`}
                type="text"
                maxLength="100"
                label="Task Name"
                component={renderTextField}
              />
            </div>
            <div className="col-sm-5 pdl-40 require">
              <Field
                name={`taskAnalysisModel[${i}].displayOrder`}
                type="text"
                maxLength="2"
                label="Display Order"
                component={renderTextField}
                normalize={isInteger}
              />
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className=" additem removeitem"
                      onClick={this.removeTaskRow.bind(this, i)}
                      title="Remove Step"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" title="Add Step" onClick={(e) => this.addTaskRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  <button className="additem"
                    onClick={this.removeTaskRow.bind(this, i)}
                    title="Remove Step"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
              }

            </div>
          </div>
        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.targetId
            ? "Edit Target"
            : "Add Target"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Target Information</h5>
                  <div className="row">
                    <div className="col-sm-12 require mt-20">
                      <Field
                        autoFocus={true}
                        name="domainId"
                        label="Domain"
                        disabled={this.props.domainIdForTarget ? true : false}
                        handleNewRequest={this.handleNewRequest}
                        options={this.state.masterDomains}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12 require mt-20">
                      <Field
                        autoFocus={true}
                        name="programId"
                        label="Program"
                        disabled={this.props.programId ? true : false}
                        handleNewRequest={this.handleNewRequest}
                        options={this.state.filteredPrograms}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 require">
                      <Field
                        name="targetName"
                        type="text"
                        onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Target Name')}
                        customError={displayCustomError('TARGETNAME', this.props.fieldError)}
                        maxLength="250"
                        label="Target Name"
                        // normalize={isValidNameWithSpace}
                        component={renderTextField}
                      />
                    </div>                    
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                        <Field
                          name="goalName"
                          type="text"
                          // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Goal Name')}
                          // customError={displayCustomError('GOALNAME', this.props.fieldError)}
                          maxLength="3000"
                          label="Goal Name"
                          // normalize={isValidNameWithSpace}
                          component={renderTextField}
                        />
                      </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                        <Field
                          name="generalizatonPlan"
                          type="text"
                          // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Goal Name')}
                          // customError={displayCustomError('GeneralizatonPlan', this.props.fieldError)}
                          maxLength="3000"
                          label="Generalizaton Plan"
                          // normalize={isValidNameWithSpace}
                          component={renderTextField}
                        />
                      </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <Field
                        name="sd"
                        type="text"
                        // onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'SD')}
                        // customError={displayCustomError('SD', this.props.fieldError)}
                        maxLength="250"
                        label="SD"
                        // normalize={isValidNameWithSpace}
                        component={renderTextField}
                      />
                    </div>
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="desiredDailyTrialsId"
                        label="Desired Daily Trials"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.desiredDailyTrials}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-sm-6 require mt-30">
                  <Field
                    autoFocus={true}
                    name="autoOpenOrderId"
                    label="Auto-Open Order"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.autoOpenOrder}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div> */}
                    <div className="col-sm-6 require mt-30">
                      <Field
                        autoFocus={true}
                        name="targetTypeId"
                        label="Target Type"
                        // handleNewRequest={this.handleNewRequest}
                        handleNewRequest = {this.middleWare}
                        options={this.props.targetType}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 mt-30">
                      <Field
                        className="mt20 mb0"
                        name="isActive"
                        label="Is Active"
                        component={renderCheckBox}
                      />
                    </div>
                  </div>
                  {this.state.showTaskAnalysisStep ?
                      <FieldArray name="taskAnalysisModel" component={this.renderTaskAnalysisTemplate} />
                  :null}
                  <div className="row">
                    <div className="col-sm-12">
                      <Field
                        name="targetInstructions"
                        type="text"
                        maxLength="4000"
                        label="Target Instructions"
                        // normalize ={isValidNameWithSpace}
                        component={renderTextArea} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="readmin-panel mt-30">
                <div className="panel-body">
                  <h5>Override Mastery Criterion</h5>
                  <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="responsePercentageId"
                        label="Response Percentage"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.responsePercentage}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="consecutiveDaysId"
                        label="Consecutive Days"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.consecutiveDays}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 mt-30">
                      <Field
                        autoFocus={true}
                        name="firstTrialMustBeIndependentId"
                        label="First Trial Must Be Independent"
                        handleNewRequest={this.handleNewRequest}
                        options={this.props.firstTrialMustBeIndependent}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 mt-20">

                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

TargetModal = reduxForm({
  form: 'TargetModalForm',
  validate,
  enableReinitialize: true,
})(TargetModal);


function mapStateToProps(state, ownProps) {
  let initialValueData = {
    isActive: true,
    taskAnalysisModel: [{}],
  };
  if (ownProps.targetId && state.target.targetListDetails) {
    // initialValueData = state.target.targetListDetails.data || null;
    let targetDetailData = state.target.targetListDetails.data || null;
    let taskAnalysisModel = [];
    if (targetDetailData.dcMasterTargetTaskAnalysisModel && targetDetailData.dcMasterTargetTaskAnalysisModel.length) {
      targetDetailData.dcMasterTargetTaskAnalysisModel.filter((data, i) => {
        taskAnalysisModel.push({
          'taskAnalysisId': data.taskAnalysisId,
          'targetId': data.targetId,
          'taskName': data.taskName,          
          'displayOrder': data.displayOrder,
        });
        return taskAnalysisModel;
      });
    } else {
      taskAnalysisModel = [{}];
    }

    initialValueData = {
      ...targetDetailData,   
      taskAnalysisModel: taskAnalysisModel,
      id: targetDetailData.id,
    };

  }

  return {
    loading: state.target.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    targetTypeName: state.target.targetListDetails != null ? state.target.targetListDetails.data.targetType ? state.target.targetListDetails.data.targetType : '' : '',
    masterDomains: state.domain.master_data ? state.domain.master_data.masterDomains : [],
    masterPrograms: state.domain.master_data ? state.domain.master_data.masterPrograms : [],
  }
}

export default connect(mapStateToProps, { getTargetDetails, checkFieldExistence, clearFieldErrorArray, saveTarget, getMasterData })(TargetModal);



// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/target/target_Modal.js